import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/model_apps`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/model_apps/${id}`, options)
    .then(response => {
      let model_apps = jsona.deserialize(response.data);
      delete model_apps.links;
      return model_apps;
    });
}

function add(model_apps) {
  
  console.log(model_apps);
  const payload = jsona.serialize({
    stuff: model_apps,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/model_apps`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(model_apps) {
  const payload = jsona.serialize({
    stuff: model_apps,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/model_apps/${model_apps.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/model_apps/${id}`, options);
}

function listByDivision(division) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/model_apps?filter[division_id]=${division}`, options)
    .then(response => {
      let model_apps = jsona.deserialize(response.data);
      delete model_apps.links;
      return model_apps;
    });
}




export default {
  list,
  get,
  add,
  update,
  listByDivision,
  destroy,
};

